module.exports = __webpack_public_path__ + "assets/validCode.9e7b7784.svg";